import React from "react";
import { SvgIcon } from "@mui/material";

const MotionDash = (props) => {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 48 48"
      shapeRendering="crispEdges"
      htmlColor="#4d4d4d"
    >
      <path d="M10.8006 25.1996V22.7996H37.2006V25.1996L10.8006 25.1996Z" />
    </SvgIcon>
  );
};

export default MotionDash;
